module.exports = __webpack_public_path__ + "static/media/Graphik-Medium.4a127c95.otf";